import React from "react";
import styled from "styled-components";
import { Colors } from "../config/Constants";
import Button from "./Button";
interface Props {
  placeholder: string;
  placeholderColor?: string;
  variant: string;
  required?: boolean;
  type?: any;
  isRounded?: boolean;
  size?: string;
  endIcon?: string;
  label?: string;
  color?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  disabled?: boolean;
  textColor?: string;
  name?: string;
  error?: boolean;
  prefilled?: boolean;
}
const Textfield = ({
  onChange,
  placeholder,
  placeholderColor,
  variant,
  type,
  isRounded,
  size,
  endIcon,
  label,
  color,
  value,
  disabled,
  textColor,
  error,
  required,
  name,
  prefilled,
}: Props) => {
  const handleEdit = () => {};
  return (
    <TextFieldWrapper>
      {label ? (
        <Label color={color}>
          {label}
          {required && <Required> *</Required>}
        </Label>
      ) : null}
      <InputField
        name={name}
        value={value}
        type={type || "text"}
        placeholder={placeholder}
        variant={variant}
        isRounded={isRounded || false}
        width={size || "medium"}
        onChange={onChange}
        color={disabled ? Colors.cloudyGrey : textColor || Colors.black}
        disabled={disabled || false}
        error={error || false}
        placeholderColor={placeholderColor}
        prefilled={prefilled}
      ></InputField>
      {endIcon ? (
        <EndIcon>
          <Button icon={endIcon} onClick={handleEdit} />
        </EndIcon>
      ) : null}
    </TextFieldWrapper>
  );
};
export default Textfield;

const TextFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const InputField = styled.input<Props>`
  font-weight: 300;
  padding: 0.75rem 0.5rem;
  background: ${(props) =>
    props.prefilled ? Colors.athensGrey : Colors.white};
  border: ${(props) =>
    props.error === true
      ? "0.0625rem solid " + Colors.red
      : props.isRounded === false
      ? "0.0625rem solid" + Colors.magnolia
      : "0.0625rem solid" + Colors.black};
  border-radius: ${(props) =>
    props.isRounded === false ? "0.25rem" : "0.5rem"};
  font-family: "Poppins-Medium";
  font-size: 0.8125rem;
  line-height: 0.75rem;
  color: ${Colors.secondaryBlack};
  :focus {
    outline: none;
  }
  ::placeholder {
    color: ${(props) =>
      props.placeholderColor ? props.placeholderColor : Colors.cloudyGrey};
    padding: 0.125rem;
    font-family: "Poppins-Book";
  }
  :disabled {
    background-color: ${(props) =>
      props.prefilled ? Colors.athensGrey : Colors.white};
    color: ${(props) =>
      props.prefilled ? Colors.secondaryBlack : Colors.logan};
    cursor: no-drop;
  }
  ::-ms-reveal,
  ::-ms-clear {
    display: none;
  }
`;

const EndIcon = styled.span`
  position: absolute;
  margin-left: -2.8rem;
  margin-top: 1.25rem;
`;
const Label = styled.label`
  color: ${(props) => (props.color ? props.color : Colors.purplishGrey)};
  font-family: "Poppins-Medium";
  font-size: 0.8125rem;
  line-height: 0.75rem;
`;
const Required = styled.span`
  color: ${Colors.red};
`;
